module.exports = __webpack_public_path__ + "static/media/tag.4aec76ab.svg";